import inMemoryJWT from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";

export const createCampaignAdmin = (data,history) => async dispatch => {
    await fetch(`${urlServer}admincampaigns/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
          
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:data
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ 
                    type: "CREATE_ADMIN_CAMPAIGNS",
                    payload: respJson.data
                });
                history.push("/Admin/MainCampaigns")
            }
        })
        .catch(error => {
            console.log()
        })
}
export const getAllCampaignAdmin = () => async dispatch => {
    await fetch(`${urlServer}admincampaigns/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
          
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        //body:data
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ 
                    type: "GET_ALL_ADMIN_CAMPAING",
                    payload: respJson.data
                });
                //history.push("/Admin/AdminCampaigns")
            }
        })
        .catch(error => {
            console.log()
        })
}
export const deleteAdminCampaign = (id,index) => async dispatch => {
    console.log();
    console.log();
    dispatch({
        type: "LOADING_DELETE_ADMIN_CAMPAING"
    });
    await fetch(`${urlServer}admincampaigns/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                campaignId : id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: "DELETE_ADMIN_CAMPAING",
                    payload:index
                });
            }           

        })
        .catch(error => {
            console.log()
        })
}
export const updateAdminCampaign= (values,history) => async dispatch => {
    dispatch({
        type: "LOADING_UPDATE_ADMIN_CAMPAING"
    });
    await fetch(`${urlServer}admincampaigns/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
       //     'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: values
    })
        .then(response => response.json())
        .then(respJson => {
            if(respJson.success){
                dispatch({
                    type: "UPDATE_ADMIN_CAMPAING",
                    payload: { data: respJson.data }
                });
                history.push("/Admin/MainCampaigns")
            }
            
        })
        .catch(error => {
            console.log()
        })
}
export const getAdminCampaignById= (id) => async dispatch => {
    dispatch({
        type: "LOADING_GET_ADMIN_CAMPAING_BY_ID"
    });
    await fetch(`${urlServer}admincampaigns/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            campaignId : id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true){
                dispatch({
                    type: "GET_ADMIN_CAMPAING_BY_ID",
                    payload: { data: respJson.data }
                });

            }
        })
        .catch(error => {
            console.log()
        })
}